import { useState } from "react";
import PropTypes from "prop-types";

const ClarificationOptions = ({
  options,
  onOptionClick,
  disabled = false,
  selectedOption: externalSelectedOption = null,
}) => {
  const [localSelectedOption, setLocalSelectedOption] = useState(null);

  // Use external selectedOption if provided, otherwise use local state
  const currentSelectedOption = externalSelectedOption || localSelectedOption;

  const handleOptionClick = (option) => {
    if (disabled) return;

    // Only update local state if no external selection is provided
    if (!externalSelectedOption) {
      setLocalSelectedOption(option);
    }
    onOptionClick(option);
  };

  // Gradient background for all options by default, only selected after selection
  // All others become greyed out (disabled/secondary style)
  const gradientClass =
    "bg-[linear-gradient(135deg,_rgb(74,111,165)_0%,_rgb(53,122,143)_100%)] text-white shadow-sm";
  const greyedClass =
    "bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-400 border border-gray-300 dark:border-gray-600 cursor-not-allowed opacity-70";
  const baseClass =
    "px-4 py-2 text-sm font-medium rounded-3xl transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2";

  const getButtonClassName = (option) => {
    // If an option is selected, only the selected one gets the gradient, others are greyed out
    if (currentSelectedOption) {
      if (currentSelectedOption === option) {
        return `${baseClass} ${gradientClass}`;
      } else {
        return `${baseClass} ${greyedClass}`;
      }
    }
    // Before selection, all options get the gradient
    return `${baseClass} ${gradientClass}`;
  };

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <div className="clarification-options mt-3">
      <div className="flex flex-wrap gap-2">
        {options.map((option, index) => (
          <button
            key={`option-${index}-${option}`}
            className={getButtonClassName(option)}
            onClick={() => handleOptionClick(option)}
            disabled={
              disabled || (!!currentSelectedOption && currentSelectedOption !== option)
            }
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

ClarificationOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  onOptionClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectedOption: PropTypes.string,
};

export default ClarificationOptions;
